export default {
    state: {
        model: {
            customers: [],
            brokers: [],
            legalEntities: [],
            sites: []
        }
    }
};
